module.exports = __webpack_public_path__ + "img/ico_return_arrow_left.d9ce2aa5.svg";